import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';

import { CookieConsentService } from '../cookie-consent.service';

@Component({
  selector: 'app-cookie-consent-dialog',
  imports: [TranslocoDirective, MatDialogTitle, MatDialogContent, MatDialogActions, MatButton],
  templateUrl: './cookie-consent-dialog.component.html',
  styleUrl: './cookie-consent-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsentDialogComponent {
  private dialogRef = inject(MatDialogRef<CookieConsentDialogComponent>);
  private cookieConsentService = inject(CookieConsentService);

  accept() {
    this.cookieConsentService.accept();
    this.dialogRef.close();
  }

  deny() {
    this.cookieConsentService.deny();
    this.dialogRef.close();
  }
}
